import DocumentTable from './DocumentTable';

export default DocumentTable;
